__turbopack_context__.v({
  "component": "style-module-scss-module__mNr5ba__component",
  "exp-theme": "style-module-scss-module__mNr5ba__exp-theme",
  "homepage-button-padding": "style-module-scss-module__mNr5ba__homepage-button-padding",
  "left-icon": "style-module-scss-module__mNr5ba__left-icon",
  "modify": "style-module-scss-module__mNr5ba__modify",
  "primary": "style-module-scss-module__mNr5ba__primary",
  "right-icon": "style-module-scss-module__mNr5ba__right-icon",
  "secondary": "style-module-scss-module__mNr5ba__secondary",
  "tertiary": "style-module-scss-module__mNr5ba__tertiary",
});
